//var ipp = require('ipp');
let Base64 = require('js-base64').Base64;

import { E_IDENTITY_MATCH_MODE, E_SELECTION_MODE, E_LINE_SPACE_RULE, optionsManager, E_SYSTEM_AUTH_MODE, E_PASTE_TYPE, SeparatorCfg, BarCodeCfg, QCCfg, E_SET_MODE, E_FERRULE_MODE, ElementCfg, E_DOC_TYPE, E_DISPLAY_MODE, E_DOCS_ORGANIZE_MODE, E_PAGES_LAYOUT_MODE, E_VIEW_MODE, E_FORMULA_STYLE, E_LAYOUT_VERTICAL_ALIGN, E_BARCODE_TYPE, E_CHECK_FIGURE_STYLE, E_DOC_FORMAT, E_ALIGN_HORIZONTAL_MODE, E_IDENTITY_OBJECT_TYPE, SearchReplaceCfg, AttachCfg, E_LIST_MODEL, E_TIME_TYPE, E_IMAGE_TYPE } from '@/components/editor/ThinkEditor.Defined';

import { GetRandStr, ShowSaveFileDialog, PopFileSelector } from '@/components/editor/ThinkEditor.Utils.js';
import { ThinkEditor } from '@/components/editor/ThinkEditor';

export class ThinkEditorDemo {
  constructor(thinkEditor) {
    this.thinkEditor = thinkEditor;
  }
  bind(thinkEditor) {
    this.thinkEditor = thinkEditor;
  }
  // 全屏事件
  TTTT() {
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit);
    this.thinkEditor.SetElementContent('sign', '');
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Browse);
    var xml_str = this.thinkEditor.GetDoc(E_DOC_FORMAT.XML, E_DOC_TYPE.Entity);
    console.log(xml_str);
  }

  /*
     SetWaterMarkConfig
     SetUserDefinedMenu
     SetFontColor
     SetFontBackColor
    SetFontType
    SetFontSize
UnionTest
UnionTimeTest
SetElementContent
SetElementContent_签名
SetParagraphContent
Run
Quit
InsertSeparator
DeleteElement,
DisplayFontSetWindow,
DisplayParagraphSetWindow,
禁用右键菜单
SetDocConfig
InsertPageNum
GetDoc
PrintDoc
SetElementSelectDateTime
SetElementSource
InputData
ToPlainTextByEscape
testDump
ReleaseEditor
CloseAllDoc
CloseDoc
AddDocAttribute
SetBackgroundColor
SetPageConfig
SetDisplayScale
InsertParagraph
GetSelectRangeContent
SetElementConfig
DeleteParagraph
ReplaceTemp
GetElementsContent
GetElementProperties
InitAsync
GetPageProperties
InputFragmentPaste
SelectAll
SetCommentResolve
forceApiEditable
GetFormulaProperties
SetCheckBoxConfig
GetCheckBoxProperties
GetDataSources
SetElementsContent
GetDocPageInfo
SetDocAttributes
SetSelection
PrintDoc1
ParseDocs_追加合并文档
SetTableConfig_显示表格线
     */
  async Test1() {
    var testCode = 'SetTableConfig_隐藏表格线';

    var json_cfg = {};
    var thinkEditor = this.thinkEditor;

    switch (testCode) {
      case 'SetTableConfig_隐藏表格线': {
        thinkEditor.SetTableConfig('table', {
          border: {
            apply: 'table',
            borderStyle: 0,
            topBorder: 1,
            bottomBorder: 1,
            leftBorder: 1,
            rightBorder: 1,
            innerHorizontalBorder: 1,
            innerVerticalBorder: 1
          }
        });
        break;
      }
      case 'ParseDocs_追加合并文档': {
        var url = '/system/emr/演示/00-演示病例/AdmissionRecord.xml'; //"/system/test/pacsdemo.jpg";
        let response = await fetch(url, {
          credentials: 'same-origin'
        });
        let subDocXml = await response.arrayBuffer();

        let mainDocName = '张三 病程记录';
        let subDocName = '换页子文档';

        var docJson = thinkEditor.ParseDocs(mainDocName, subDocName, subDocXml, {
          organizeMode: E_DOCS_ORGANIZE_MODE.UnionSection,
          recoverSelection: 2,
          setUnionSelection: 1
        });
        thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});
        break;
      }
      case 'GetDoc12': {
        var docJson = thinkEditor.GetDoc(E_DOC_FORMAT.XML, E_DOC_TYPE.Entity, { multipleDocs: true });
        console.log(docJson);
        break;
      }
      case 'SetElementContent1': {
        thinkEditor.SetElementContentById('', 'id1');
        //thinkEditor.SetElementContent({ id: '' }, '气促,呼吸困难2');
        //thinkEditor.SetElementContentById('id3', '气促,呼吸困难');

        /*thinkEditor.SetElementsContent([
          { id: 'id2', content: 'id2' },
          // { id: 'id3', content: '气促,呼吸困难' },
          { id: 'id3', checked: ['气促', '呼吸困难'] },

          { sourceClass: '住院资料', sourceId: '住院号', content: 'sourceClass' }
        ]);*/
        break;
      }
      case 'PrintDoc1': {
        let printJson = {
          sharpness: 2.0,
          rotate: 0,
          pageRange: '',
          view: {
            mode: E_VIEW_MODE.Print,
            hideElementHint: 1,
            displayCarriageReturn: false,
            displayEditAuxiliary: 0,
            displaySelectionEffect: 0
          }
        };
        thinkEditor.PrintDoc(printJson);
        break;
      }
      case 'SetSelection': {
        thinkEditor.SetSelection({ mode: E_SELECTION_MODE.SelectToDocEnd });
        break;
      }
      case 'SetDocAttributes': {
        let docAttrs = thinkEditor.GetDocAttributes();
        thinkEditor.SetDocAttributes({ user1: 'abcc', user2: '2222' });
        docAttrs = thinkEditor.GetDocAttributes();
        break;
      }
      case 'GetDocPageInfo': {
        let pageNumInfo = thinkEditor.GetDocPageInfo();
        break;
      }
      case 'SetElementsContent': {
        //thinkEditor.SetBarCodeConfig('门诊号', { text: '124bggb' });
        thinkEditor.SetElementsContent([
          {
            id: 'qita',
            content: '自定义'
          },
          {
            id: 'qita1',
            content: '自定义1'
          }
        ]);
        break;
      }
      case 'SetBarCodeConfig': {
        //thinkEditor.SetBarCodeConfig('门诊号', { text: '124bggb' });
        thinkEditor.SetBarCodeConfig('门诊号', { data: 'NjY5OTg4ODg4' });
        break;
      }
      case 'GetDataSources': {
        var ret = this.thinkEditor.GetDataSources({ mode: E_IDENTITY_MATCH_MODE.MatchIdentity, sourceClasses: ['基本资料', 'iptTemporaryDrord'] });
        console.log(ret);
        break;
      }
      case 'SetDataSources': {
        var ret = this.thinkEditor.SetDataSources(null, { 体征信息: [{ 日期: '2025-09-30' }, { 日期: '2025-09-31' }] });
        break;
      }
      case 'GetCheckBoxProperties': {
        var ret = this.thinkEditor.GetCheckBoxProperties({ mode: 0 });
        break;
      }
      case 'SetElementContent_签名': {
        //let signImage = `data:image/png;base64,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`;

        let signImage = `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`;

        var md5 = this.thinkEditor.SetImageResourceBase64('sign.bmp', signImage, signImage.length, {}); // (E_VIEW_MODE::Edit);
        //var md6 = this.thinkEditor.InsertImageBase64('', 2, 2, 'filename', signImage, signImage.length, {});
        var signFragment = "<Fragment><Image width='2' height='0.8' file='当前医师电子签名.jpg' md5='" + md5 + "'/></Fragment>";

        this.thinkEditor.SetElementContent('DE02_01_039_00_ZYYSQM', signFragment);
        break;
      }
      case 'SetFontSize': {
        thinkEditor.SetFontSize(0.5);
        break;
      }
      case 'SetInputFocus': {
        thinkEditor.SetInputFocus(true);
        break;
      }
      case 'SetSources': {
        var ret = thinkEditor.SetSources([{ sourceClass: '患者档案信息', sourceId: '婚姻', content: '未婚' }]);
        break;
      }
      case 'GetTableProperties': {
        var ret = thinkEditor.GetTableProperties('123', {});
        break;
      }
      case 'SetCheckBoxConfig': {
        //过时 var ret = thinkEditor.SetCheckBoxConfig('', { option: { optionName: '乙类传染病' }, checked: ['infectiousDiseaseB&乙类传染病&登革热', 'infectiousDiseaseB&乙类传染病&传染病非典型肺炎'] });
        var ret = thinkEditor.SetCheckBoxConfig({ optionNames: ['linkageTest'] }, { checked: ['2'] });
        // thinkEditor.SetCheckBoxConfig({ ids: ['a', 'c'] }, { checked: true });

        break;
      }
      case 'GetFormulaProperties': {
        var ret = thinkEditor.GetFormulaProperties({});
        break;
      }
      case 'forceApiEditable': {
        thinkEditor.SetEditorConfig({ forceApiEditable: true });
        thinkEditor.SetElementContent('gender', '男123');

        break;
      }
      case 'SetEditorFocus': {
        thinkEditor.SetEditorFocus();

        break;
      }
      case 'SetCommentResolve': {
        thinkEditor.SetCommentResolve({ resolve: false });

        break;
      }
      case 'SetFontInfo': {
        var fontList = this.thinkEditor.GetFontInfo();
        thinkEditor.SetFontInfo([{ fontName: '小标宋', file: '方正小标宋_GBK.TTF' }], { reset: true });
        fontList = this.thinkEditor.GetFontInfo();
        break;
      }
      case 'SelectAll': {
        thinkEditor.PushSelection();
        thinkEditor.SelectAll();
        thinkEditor.SetFontConfig({
          fontName: '宋体',
          fontSizeItem: '小四'
        });
        thinkEditor.SetParagraphConfig('', {
          lineSpaceRule: 1,
          lineSpaceValue: 1.5
        });
        thinkEditor.PopSelection();
        break;
      }
      case 'InputFragmentPaste': {
        var url = '/system/test/htmlFormat'; //"/system/test/pacsdemo.jpg";
        let response = await fetch(url, {
          credentials: 'same-origin'
        });
        let htmlStr = await response.text();
        this.thinkEditor.InputFragmentPaste(E_DOC_FORMAT.HTML, htmlStr);
        break;
      }
      case 'SetTableData1': {
        let tableXml =
          "<Table><Row><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />主要诊断:流感伤寒型钩端螺旋体病?</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />A27.800x001</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />临床未确定</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell></Row><Row><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />其他诊断:干燥综合征性肾小管间质肾炎?</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />M35.006+N16.4*</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />临床未确定</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell></Row><Row><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />钩端螺旋体病肺出血型?</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />A27.900x004</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />临床未确定</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell></Row><Row><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />混合性结缔组织病肾损害?</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />M35.102</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />临床未确定</Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell></Row></Table>";
        this.thinkEditor.SetTableData('diagtable', tableXml, { mode: 0, forbidInheriIdentiy: 1 });
        return;
        tableXml = "<Table><Row><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />17.9700x028</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />2025-04-28 11:04:19</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />三级手术</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />桡骨下1/3骨折合并下尺桡关节脱位手法整复术</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />成诗梅</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />小刘</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />杜玉平</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />Ⅰ</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />椎管内麻醉</Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' /></Paragraph></Cell><Cell id='' borderWidth='0.010' downDiagonalBorderWidth='0.010' upDiagonalBorderWidth='0.010' borderStyle='1' borderColor='333333' downDiagonalBorderColor='333333' upDiagonalBorderColor='333333'><Paragraph><Font size='0.32' />1</Paragraph></Cell></Row>        </Table>";

        this.thinkEditor.SetTableData('operatetable', tableXml, { mode: 0, forbidInheriIdentiy: 1 });

        break;
      }
      case 'SetTableData': {
        let rowHeight = 1.0;

        let tableXml = '<Table>';
        /*
        tableXml += `<Row height='${rowHeight}'>`;
        tableXml += `<Cell ><Paragraph>a</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>b</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>c</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>d</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>e</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>f</Paragraph></Cell>`;
        tableXml += `</Row>`;

        tableXml += `<Row height='${rowHeight}'>`;
        tableXml += `<Cell ><Paragraph>a</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>b</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>c</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>d</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>e</Paragraph></Cell>`;
        tableXml += `<Cell ><Paragraph>f</Paragraph></Cell>`;
        tableXml += `</Row>`;

        tableXml += '</Table>';
       
        this.thinkEditor.SetTableData('generalCheck', tableXml, {}); */
        //var result = this.thinkEditor.SetTableData();
        break;
      }
      case 'GetPageProperties': {
        var result = this.thinkEditor.GetPageProperties();
        break;
      }
      case 'InitAsync': {
        await this.thinkEditor.InitAsync();

        var newDocName = '123';
        var url = '/system/emr/thinkeditor.xml'; //"/system/test/pacsdemo.jpg";
        let response = await fetch(url, {
          credentials: 'same-origin'
        });
        let xmlStr = await response.arrayBuffer();
        this.thinkEditor.ParseDoc(newDocName, xmlStr, E_DOCS_ORGANIZE_MODE.Single);
        this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});

        break;
      }
      case 'SetParagraphLineSpacingValue': {
        var result = this.thinkEditor.SetParagraphLineSpacingValue(undefined);
        break;
      }

      case 'GetElementProperties': {
        var result = this.thinkEditor.GetElementProperties({});
        break;
      }
      case 'GetElementsContent': {
        var result = this.thinkEditor.GetElementsContent([], { mode: 0 });
        break;
      }
      case 'ReplaceTemp': {
        var doc_name = this.thinkEditor.GetVisibleDocName();

        await this.thinkEditor.CloseDoc(doc_name);
        var newDocName = '123';
        var url = '/system/emr/thinkeditor.xml'; //"/system/test/pacsdemo.jpg";
        let response = await fetch(url, {
          credentials: 'same-origin'
        });
        let xmlStr = await response.arrayBuffer();
        this.thinkEditor.CreateDoc(newDocName);
        this.thinkEditor.SetDocType(E_DOC_TYPE.Entity);
        this.thinkEditor.ParseDoc(newDocName, xmlStr, E_DOCS_ORGANIZE_MODE.Single);
        this.thinkEditor.SetEditMode(false, false, false, false, false);
        this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});

        this.thinkEditor.showName = this.thinkEditor.GetVisibleDocName();
        break;
      }
      case 'DeleteParagraph': {
        this.thinkEditor.DeleteParagraph({
          ids: ['主诉', '既往史']
        });

        break;
      }
      case 'SetReviseConfig': {
        this.thinkEditor.SetReviseConfig({
          mode: 1,
          cleanAddRevise: true,
          cleanDeleteRevise: true
        });

        break;
      }
      case 'GetOutline': {
        var outline = this.thinkEditor.GetOutline({
          mode: 2
        });
        console.log(JSON.stringify(outline));
        break;
      }
      case 'SetElementConfig': {
        this.thinkEditor.SetElementConfig(
          '',
          /*{
            mode: 1,
            id: 'a',
            ids: ['a']
          }*/ {
            hint: '请输入时间',
            tips: 'aaaa',
            inputHandle: { inputMode: 3 }
          }
        );
        break;
      }
      case 'InputData': {
        this.thinkEditor.InputData('<Fragment>' + '<LF/><Element id="住院证" name="住院证" cfg="30000" hint="请输入">建议住院治疗。</Element>' + '</Fragment>');
        this.thinkEditor.SetElementConfig('住院证', {
          hide: 0,
          lockedContent: 0,
          forbidDelete: 0
        });
        //this.thinkEditor.DeleteElement('住院证', {});
        break;
      }
      case 'SetOptions': {
        //-----------------------------------
        let arr = [
          {
            optionClass: 'GI',
            optionId: '眼别',
            items: [
              { id: '619', groupId: '', weight: 1, content: '左眼' },
              { id: '620', groupId: '', weight: 1, content: '右眼' },
              { id: '621', groupId: '', weight: 1, content: '双眼' }
            ]
          }
        ];
        this.thinkEditor.SetOptions(arr);
        const optionsData = [
          {
            optionClass: '专科检查-四肢',
            optionId: '足背动脉搏动',
            items: [
              {
                id: '足背动脉搏动可触及',
                group: '1',
                weight: 1,
                content: '足背动脉搏动可触及'
              },
              {
                id: '足背动脉搏动不可触及',
                group: '1',
                weight: 1,
                content: '足背动脉搏动不可触及'
              },
              {
                id: '足背动脉搏动正常',
                group: '1',
                weight: 1,
                content: '足背动脉搏动正常'
              }
            ]
          }
        ];

        const optionsData1 = [
          {
            optionClass: '专科检查-四肢',
            optionId: '足背动脉搏动',
            items: [
              {
                id: '1111',
                group: '1',
                weight: 1,
                content: '1111'
              },
              {
                id: '222222',
                group: '1',
                weight: 1,
                content: '222222'
              },
              {
                id: '3333',
                group: '1',
                weight: 1,
                content: '3333'
              }
            ]
          }
        ];

        optionsManager.AddOptions(optionsData);
        console.log(optionsManager.GetOption('专科检查-四肢', '足背动脉搏动'));
        optionsManager.AddOptions(optionsData1);
        console.log(optionsManager.GetOption('专科检查-四肢', '足背动脉搏动'));
        //------------------------------------------
        break;
      }
      case 'GetDocProperties': {
        var docProperties = this.thinkEditor.GetDocProperties();
        console.warn(docProperties);
        break;
      }
      case 'InsertTable': {
        var test = this.thinkEditor.InsertTable({
          id: 'id',
          name: 'name',
          rowsCount: 1,
          colsCount: 2,
          lockedFormat: false,
          alignHorizontalMode: '0',
          leftIndent: '0.00',
          topPadding: '0.1',
          bottomPadding: '0.1',
          leftPadding: '0.1',
          rightPadding: '0.1',
          border: {
            apply: 'table',
            topBorderStyle: 0,
            bottomBorderStyle: 0,
            rightBorderStyle: 0,
            innerHorizontalBorderStyle: 0,
            innerVerticalBorderStyle: 0,
            leftBorderStyle: 0,
            rightBorderStyle: 0,
            borderWidth: '0.02'
          }
        });
        break;
      }
      case 'SetTableConfig': {
        var test = this.thinkEditor.SetTableConfig('', {
          lockedFormat: false,
          alignHorizontalMode: '0',
          leftIndent: '0.00',
          topPadding: '0.1',
          bottomPadding: '0.1',
          leftPadding: '0.1',
          rightPadding: '0.1',
          border: {
            borderSetMode: 0,
            borderStyle: 0,
            topBorderColor: 'ffd9d9d9',
            bottomBorderColor: 'ffd9d9d9',
            leftBorderColor: 'ffd9d9d9',
            rightBorderColor: 'ffd9d9d9',
            borderWidth: '0.02'
          }
        });
        break;
      }
      case 'GetSelectRangeContent': {
        var test = this.thinkEditor.GetSelectRangeContent(E_DOC_FORMAT.TEXT);
        break;
      }
      case 'InsertParagraph': {
        this.thinkEditor.InsertParagraph({});
        break;
      }
      case 'InsertElement': {
        var cfg = {
          id: 'MedicalVisitInfo_OrganizationName',
          hint: '机构名称',
          name: '机构名称',
          readOnly: true,
          afterTag: '',
          inputHandle: {
            inputMode: 'InputText'
          },
          source: {
            sourceClass: 'AssociationJson',
            sourceId: 'MedicalVisitInfo_OrganizationName'
          }
        };
        //this.thinkEditor.InsertElement({ font: { fontSizeItem: '小五' } });

        this.thinkEditor.InsertElement(cfg);

        break;
      }
      case 'SetDisplayScale': {
        this.thinkEditor.SetDisplayScale(E_PAGES_LAYOUT_MODE.ViewWidth, 1);
        break;
      }
      case 'SetPageConfig': {
        this.thinkEditor.SetPageConfig({
          width: 21,
          height: 29.7,
          id: '',
          name: '',
          notSave: false,
          alignVerticalLayout: 'Bottom',
          bindLine: {
            margin: 0,
            position: 16,
            showLine: false
          },
          bottomPadding: 2,
          leftPadding: 3.14,
          rightPadding: 3.14,
          topPadding: 2.54,
          header: {
            topMargin: 2,
            hide: 0,
            showLine: false,
            locked: false,
            dynamicLocked: false
          },
          footer: {
            bottomMargin: 0.3,
            hide: 0,
            showLine: false,
            locked: false,
            dynamicLocked: false
          },
          evenPageDiff: false,
          fristPageDiff: false
        });
        break;
      }
      case 'SetFontBackColor': {
        this.thinkEditor.SetFontBackColor('000000');
        //this.thinkEditor.SetFontColor('00000000');
        break;
      }
      case 'SetFontColor': {
        this.thinkEditor.SetFontColor('000000');
        //this.thinkEditor.SetFontColor('00000000');
        break;
      }
      case 'SetBackgroundColor': {
        //RGBA2Color({ a: 255, r: 66, g: 133, b: 244 })
        this.thinkEditor.SetBackgroundColor('ffF5F5F5');
        break;
      }
      case 'SetDefaultFont': {
        this.thinkEditor.SetDefaultFont('宋体', '小四');
        break;
      }
      case 'AddDocAttribute': {
        this.thinkEditor.AddDocAttribute('key1', 'value1');
        this.thinkEditor.AddDocAttribute('key2', 'value2');
        var docProperties = this.thinkEditor.GetDocProperties();
        console.log(docProperties);
        break;
      }
      case 'ReleaseEditor': {
        this.thinkEditor.UnInit();
        break;
      }
      case 'testDump': {
        this.thinkEditor.SetEditorConfig({ testDump: 1 });
        break;
      }

      case 'ToPlainTextByEscape': {
        var str1 = '(快&检) <1"0.00 mg/L11111&2\'222<222<23>3333>33"33>3\'';
        //'(快&amp;检) &lt;1&quot;0.00 mg/L11111&amp;2&apos;222&lt;222&lt;23&gt;3333&gt;33&quot;33&gt;3&apos;'
        var plainText1 = this.thinkEditor.ToPlainTextByEscape(str1);
        plainText1 += '<LF/>';

        var str2 = '(放入元素中&) <1"0.00 mg/L有特殊字符<23>3333>33"33>3\'';
        var plainText2 = this.thinkEditor.ToPlainTextByEscape(str2);
        plainText2 = '<Element>' + plainText2 + '</Element>';
        //'<Fragment>(快&amp;检) &lt;1&quot;0.00 mg/L11111&amp;2&apos;222&lt;222&lt;23&gt;3333&gt;33&quot;33&gt;3&apos;</Fragment>'
        var fragmentStr = '<Fragment>' + plainText1 + plainText2 + '</Fragment>';

        this.thinkEditor.InputData(fragmentStr);
        break;
      }
      case 'ToPlainTextByCDATA': {
        var str = '(快&检) <1"0.00 mg/L111<![CDATA[11&2\'222<222<23>33]]>33>33"33>3\'';
        //`<![CDATA[(快&检) <1"0.00 mg/L11111&2'222<222<23>3333>33"33>3']]>`
        var plainText = this.thinkEditor.ToPlainTextByCDATA(str);
        //`<Fragment><![CDATA[(快&检) <1"0.00 mg/L11111&2'222<222<23>3333>33"33>3']]></Fragment>`
        var fragmentStr = '<Fragment>' + plainText + '</Fragment>';

        this.thinkEditor.InputData(fragmentStr);
        break;
      }
      case 'SetElementSource': {
        var ele_cfg = new ElementCfg();
        ele_cfg.dynamic_load_ = true;
        this.thinkEditor.SetElementSource('DFE02698-0904-464D-8ED0-E66E67BFC9FB', '', '', ele_cfg);
        break;
      }
      case 'SetElementSelectDateTime':
        {
          this.thinkEditor.SetElementSelectDateTime('', 4);
        }
        break;
      case 'PrintDoc':
        {
          console.log('--------PrintDoc-----------');
          this.thinkEditor.SetParagraphConfig(
            { ids: ['nodraw2', 'nodraw22'] },
            {
              hide: true
            }
          );

          this.thinkEditor.SetParagraphConfig('nodraw22', {
            hide: true
          });
          this.thinkEditor.SetParagraphConfig('nodraw22', {
            hide: true
          });
          await this.thinkEditor.PrintDocAsync({
            sharpness: 2.0,
            rotate: 0,
            mode: 0,
            pagesRange: '',
            view: {
              mode: E_VIEW_MODE.Print,
              hideElementHint: true
            }
          });
          this.thinkEditor.SetParagraphConfig('nodraw22', {
            hide: false
          });
          this.thinkEditor.SetParagraphConfig('nodraw22', {
            hide: false
          });

          this.thinkEditor.SetParagraphConfig(
            { ids: ['nodraw2', 'nodraw22'] },
            {
              hide: false
            }
          );
        }
        break;
      case 'GetDoc_JsonXmlTest':
        {
          var docXml = this.thinkEditor.GetDoc(E_DOC_FORMAT.XML, E_DOC_TYPE.Entity);
          console.log(docXml);
          var docJson = JSON.parse(docXml);
          console.log(docJson.xml);
          var docStr = Base64.decode(docJson.xml);
          console.log(docStr);
        }
        break;
      case 'InsertPageNum':
        {
          this.thinkEditor.InsertPageNum({ scope: E_PAGE_NUM_SCOPE.WholeDocnment, style: E_PAGE_NUM_STYLE.OrderListModel_0, format: E_PAGE_NUM_FORMAT.PageOrderPagesCountFormat });
        }
        break;
      case 'SetDocConfig':
        {
          //json_cfg.dynamicLocked = true;//_禁止正文编辑
          json_cfg.disableParagraphLockedTip = true;
          this.thinkEditor.SetDocConfig('', json_cfg);
        }
        break;
      case '禁用右键菜单':
        {
          json_cfg.clipBoardMenuDisplayMode = 0;
          json_cfg.attributeMenuDisplayMode = 1;
          json_cfg.operationMenuDisplayMode = 0;
          this.thinkEditor.SetEditorConfig(json_cfg);
        }
        break;
      case 'DisplayFontSetWindow':
        {
          this.thinkEditor.DisplayFontSetWindow(E_DISPLAY_MODE.Show);
        }
        break;
      case 'DisplayParagraphSetWindow':
        {
          this.thinkEditor.DisplayParagraphSetWindow(E_DISPLAY_MODE.Show);
        }
        break;
      case 'DeleteElement':
        {
          this.thinkEditor.DeleteElement('');
        }
        break;
      case 'InsertSeparator':
        {
          this.thinkEditor.InsertSeparator(0, 0.8, {
            lineWidth: 0.1,
            color: 'ffff0000'
          });
        }
        break;
      case 'SetParagraphContent':
        {
          this.thinkEditor.SetParagraphContent('主诉', '无UI模式');
        }
        break;
      case 'SetElementContent':
        {
          let fragement = `<Fragment>
          <Element id='menses' cfg='10000' hint='月经史'>
            <Formula xCfg='1' width='1.739' height='1.652' lCfg='2'>
              <Unit eCfg='5' width='0.580' height='0.826' padding='0.190'>
                <Paragraph lineSpaceValue='1.000'>
                  <Element cfg='30000' inputMode='3' hint='初潮年龄'>1</Element>
                  <Font color='808080'/>
                </Paragraph>
              </Unit>
              <Unit eCfg='5' width='0.580' height='0.826' padding='0.190'>
                <Paragraph lineSpaceValue='1.000'>
                  <Element cfg='30000' inputMode='1' hint='经期'>2</Element>
                  <Font color='808080'/>
                </Paragraph>
              </Unit>
              <Unit eCfg='5' width='0.580' height='0.826' padding='0.190'>
                <Paragraph lineSpaceValue='1.000'>
                  <Element cfg='30000' inputMode='1' hint='周期'>4</Element>
                  <Font color='808080'/>
                </Paragraph>
              </Unit>
              <Unit eCfg='5' width='0.580' height='0.826' padding='0.190'>
                <Paragraph lineSpaceValue='1.000'>
                  <Element cfg='30000' inputMode='3' hint='末次月经'>3</Element>
                  <Font color='808080'/>
                </Paragraph>
              </Unit>
            </Formula>
            <Font color='0'/>，月经规律周期<Element cfg='30000' inputMode='2' optionClass='入院记录' optionId='月经规律周期' items='正常' hint='请输入'>正常</Element>，月经量<Element cfg='30000' inputMode='2' optionClass='入院记录' optionId='月经量' items='正常' hint='请输入'>正常</Element>，色暗，<Element cfg='30000' inputMode='2' optionClass='入院记录' optionId='有无' items='无' hint='请输入'>无</Element>血块，<Element cfg='30000' inputMode='2' optionClass='入院记录' optionId='有无' items='无' hint='请输入'>无</Element>痛经。
            
            </Element>
        </Fragment>`;
          this.thinkEditor.SetElementContent('婚姻', '未婚');
        }
        break;
      case 'Copy':
        {
          this.thinkEditor.Copy();
        }
        break;
      case 'loseContext':
        {
          //模拟丢失
          this.thinkEditor.gl.getExtension('WEBGL_lose_context').loseContext();
        }
        break;
      case 'SetViewMode_fontColor':
        {
          json_cfg.fontColor = 'ff0000ff';
          this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, json_cfg);
        }
        break;
      case 'UnionTest':
        {
          //this.thinkEditor.CloseAllDoc();
          //新建文档编辑器
          var docName = '合并';
          var thinkEditor = new ThinkEditor({
            lib: '/editor/', //库文件在服务器上路径
            fontPath: '/editor_fonts/', //字体文件在服务器上路径
            editorId: docName + '_' + GetRandStr(), //文档编辑器Id，用于区分不同的文档编辑器
            auth: { mode: E_SYSTEM_AUTH_MODE.Demonstration }
          });

          await thinkEditor.Init();

          var url = '/system/emr/1.xml'; //"/system/test/pacsdemo.jpg";
          let response = await fetch(url, {
            credentials: 'same-origin'
          });
          let xml1 = await response.arrayBuffer();

          json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionSection;
          json_cfg.recoverSelection = 2;
          json_cfg.setUnionSelection = 0;
          thinkEditor.CreateDoc('病程记录'); //@20220722 必需，才能设置编辑者信息
          thinkEditor.SelectDoc('病程记录');
          thinkEditor.SetEditorInfo('pc', 'zltest', 'zl', 1, '');
          thinkEditor.ParseDocs('病程记录', '首次病程记录-1-13333', xml1, json_cfg);

          url = '/system/emr/2.xml'; //"/system/test/pacsdemo.jpg";
          response = await fetch(url, {
            credentials: 'same-origin'
          });
          let xml2 = await response.arrayBuffer();
          json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionSection;
          json_cfg.recoverSelection = 2;
          json_cfg.setUnionSelection = 1;
          thinkEditor.ParseDocs('病程记录', '首次病程记录-1-147449', xml2, json_cfg);

          url = '/system/emr/3.xml'; //"/system/test/pacsdemo.jpg";
          response = await fetch(url, {
            credentials: 'same-origin'
          });
          let xml3 = await response.arrayBuffer();
          json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionSection;
          json_cfg.recoverSelection = 2;
          json_cfg.setUnionSelection = 0;
          thinkEditor.ParseDocs('病程记录', '首次病程记录-1-3', xml3, json_cfg);

          url = '/system/emr/4.xml'; //"/system/test/pacsdemo.jpg";
          response = await fetch(url, {
            credentials: 'same-origin'
          });
          let xml4 = await response.arrayBuffer();
          json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionSection;
          json_cfg.recoverSelection = 2;
          json_cfg.setUnionSelection = 0;
          thinkEditor.ParseDocs('病程记录', '首次病程记录-1-4', xml4, json_cfg);

          //thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});

          let printCfg = {};
          printCfg.printMode = 1; // 0：视图打印 1：矢量打印
          printCfg.view = {
            mode: E_VIEW_MODE.Print,
            hideElementHint: true
          };

          //[0] 注意await,后续可能关闭文档或编辑器
          await thinkEditor.PrintDocAsync(printCfg);

          //[1]如果ThinkEditor还需使用，当前文档不需使用了，则关闭文档
          //thinkEditor.CloseDoc(docName);
          //或;
          //thinkEditor.CloseAllDoc();

          //[2]如果ThinkEditor不再使用了，则释放编辑器及内存
          console.warn('thinkEditor.UnInit()'); //必要，释放内存
          thinkEditor.UnInit();
        }
        break;
      case 'UnionTimeTest':
        {
          var url = '/system/emr/AdmissionRecord.xml'; //"/system/test/pacsdemo.jpg";
          let response = await fetch(url, {
            credentials: 'same-origin'
          });
          let xml1 = await response.arrayBuffer();

          json_cfg.organizeMode = 2;
          json_cfg.recoverSelection = 2;
          json_cfg.setUnionSelection = 0;

          console.time('UnionTimeTest1');
          for (var i = 0; i < 100; i++) {
            this.thinkEditor.ParseDocs('0', i + '', xml1, json_cfg);
          }
          console.timeEnd('UnionTimeTest1');

          console.time('UnionTimeTest2');
          this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, {});
          console.timeEnd('UnionTimeTest2');
        }
        break;
      case 'SetFontType':
        this.thinkEditor.SetFontType('黑体');
        break;
      case 'SetWaterMarkConfig':
        var attach_id = 'waterMarkTest';
        json_cfg.fontName = '宋体';
        json_cfg.size = 1.0;
        json_cfg.Fragment = '文字水印测试';

        json_cfg.angle = 315;

        json_cfg.forbidPrint = 0;
        json_cfg.repeat = 1;
        json_cfg.fillMode = 0;

        json_cfg.topPadding = 2.8;
        json_cfg.bottomPadding = 2.8;
        json_cfg.leftPadding = 2.8;
        json_cfg.right_Padding = 2.8;

        //json_cfg.top_padding = 1.8;
        //json_cfg.bottom_padding = 1.8;
        //json_cfg.left_padding = 1.8;
        //json_cfg.right_padding = 1.8;

        this.thinkEditor.SetWaterMarkConfig(attach_id, json_cfg);
        break;
      case 'SetUserDefinedMenu':
        //var json_str = `[{"type":"user_defined1","text":"自定义菜单1","code":0},{"type":"user_defined2","text":"自定义菜单2","code":2}]`;
        var json_str = `[]`;
        var json_obj = JSON.parse(json_str);
        this.thinkEditor.SetUserDefinedMenu(json_obj);
        break;
      default:
        break;
    }

    return;
    /*
        this.thinkEditor.SetElementSelectDateTime("name", E_TIME_TYPE.DateTime);
        */
    /*
        const json = {};
        json.srcDocName = "Compare1";
        json.destDocName = "Compare2";

        var url = "/system/emr/Compare1.xml";//"/system/test/pacsdemo.jpg";
        let response = await fetch(url,  {credentials:'same-origin'});
        let src_data = await response.arrayBuffer();
        url = "/system/emr/Compare2.xml";//"/system/test/pacsdemo.jpg";
        response = await fetch(url,  {credentials:'same-origin'});
        let dest_data = await response.arrayBuffer();
        this.thinkEditor.SetCompareDocs(json,src_data,dest_data);
        return;
*/
    /*
        const json1 = {};
        json1.ids = [];
        json1.ids[0] = "asdf";
        json1.ids[1] = "test";
        this.thinkEditor.SelectAnnotates(json1);
        return;
*/
    /*
        var json_obj={};
        json_obj.locked = 1;
        //json_obj["top-border-style"] = 0;
        this.thinkEditor.SetHeaderConfig(json_obj);
        return;*/
    /*
        var json = {};
        json.hide = true;
        //json.display_revise_del = false;
        //json.display_qualitycontrol_infobox
        await this.thinkEditor.SetParagraphConfig("主诉", json);
        return;    */
    /*
       this.thinkEditor.SetElementContent("6CAEC966-0CC7-4C7D-ACFC-8436704A4708", "5689");
       this.thinkEditor.GetDoc(E_DOC_FORMAT.XML,E_DOC_TYPE.Entity);
       return;    */
    /*var json_cfg ={};
        json_cfg.check_figure_style =0;
        json_cfg.multiple_choice =1;
        this.thinkEditor.InsertCheckBoxGroup("1234", "病史", "吸烟史", json_cfg);
*/
    /*
    var json_cfg ={};
    //json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.MergeContent;
    json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionContent;
    //json_cfg.organizeMode = E_DOCS_ORGANIZE_MODE.UnionSection

    this.thinkEditor.CreateDoc("frist");

    this.thinkEditor.SetEditorInfo("pc", "zltest","zl",1,"");

    var url = "/system/test/merge_test/JumpDemo.xml";//"/system/test/pacsdemo.jpg";
    let emr_response = await fetch(url,  {credentials:'same-origin'});
    let data = await emr_response.arrayBuffer();
    this.thinkEditor.ParseDocs("frist", "", data, json_cfg);

    var url = "/system/test/merge_test/wg20220211.xml";//"/system/test/pacsdemo.jpg";
    emr_response = await fetch(url,  {credentials:'same-origin'});
    data = await emr_response.arrayBuffer();
    this.thinkEditor.ParseDocs("frist", "1", data, json_cfg);

    var url = "/system/test/merge_test/wg20220208.xml";//"/system/test/pacsdemo.jpg";
    emr_response = await fetch(url,  {credentials:'same-origin'});
    data = await emr_response.arrayBuffer();
    this.thinkEditor.ParseDocs("frist", "2", data, json_cfg);


    this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit,{});

    return;*/
    /*
    this.thinkEditor.SetParagraphListMode(E_LIST_MODEL.OrderListModel_5);
    return;*/
    /*
        var url = "/system/test/668888.jpg";//"/system/test/pacsdemo.jpg";
        //var thinkEditorDemo = this;
        let response = await fetch(url,  {credentials:'same-origin'});
        let img_data = await response.arrayBuffer();
        var img_name = "668888.jpg";
        var img_md5 = this.thinkEditor.SetImageResource(img_name, img_data, img_data.length);
        console.log(img_md5);


        var attach_id = "waterMarkImg";

        let json_cfg={};
        json_cfg.image_name = img_name;
        json_cfg.md5 = img_md5;
        json_cfg.alpha = 0xff;
        json_cfg.forbid_print = 1;
        json_cfg.repeat = 0;
        json_cfg.fill_mode = 1;

        json_cfg.top_padding = 0;
        json_cfg.bottom_padding = 0;
        json_cfg.left_padding = 0;
        json_cfg.right_padding = 0;

        //json_cfg.top_padding = 1.8;
        //json_cfg.bottom_padding = 1.8;
        //json_cfg.left_padding = 1.8;
        //json_cfg.right_padding = 1.8;

        this.thinkEditor.SetWaterMarkConfig(attach_id, json_cfg);
*/
    /*
    let attach_cfg = new AttachCfg();
    attach_cfg.layer_ = 0;
    attach_cfg.type_ = 1;
    attach_cfg.source_ = 0;
    attach_cfg.forbid_print_ = 1;
    attach_cfg.texture_type_ = 0;
    attach_cfg.repeat_ = 1;
    let ret1 = this.thinkEditor.SetWaterMarkImage(attach_id,0xff, 0, 0,attach_cfg,img_name, img_md5);
    console.log(ret1);
    */
    //let ret2 = this.thinkEditor.SetWaterMarkPadding(attach_id,1.8, 1.8,1.8, 1.8);
    // console.log(ret2);

    /*
        var editor_config={};
        //editor_config.debug_flush = true;
        editor_config.disable_edit_limit = true;
        this.thinkEditor.SetEditorConfig(editor_config);
*/
    /*
         var json = {};
         var commnet_id = this.thinkEditor.InsertComment("","", json);
         var tt = commnet_id;
         */
    /*
        var json = {};
        json.trigger_type = 0;
        json.execute_mode = 0;
        json.action = `this.element.value=='吸烟' ? smoke.element.visible=true:smoke.element.visible=false`;

        await this.thinkEditor.SetElementConfig("", json);
*/
    /*
var json = {};
json.forbid_series_split = true;
json.split_paragrah_mode = 2;
//json.display_revise_del = false;
//json.display_qualitycontrol_infobox
await this.thinkEditor.SetParagraphConfig("123", json);

*/
    /*
            var editor_config={};
    //editor_config.debug_flush = true;
    editor_config.debug_event = true;
    editor_config.log_level = 10;
    this.thinkEditor.SetEditorConfig(editor_config);
*/

    /*
var json = {};
json.delete_mode = true;
json.split_paragrah_mode = 1;
//json.display_revise_del = false;
//json.display_qualitycontrol_infobox
this.thinkEditor.SetElementConfig("", json);
        //this.thinkEditor.SetElementBase("", "设置-测试", "", "{", "}", "", "");
        //const cfg = new SearchReplaceCfg();
//const aa = this.thinkEditor.GetObjectFragment(E_IDENTITY_OBJECT_TYPE.Paragraph, "103",E_DOC_FORMAT.XML, cfg);
*/
    /*
thinkEditor.DisplayImageSetWindow(1);
//return;*/
    //this.thinkEditor.DisplayElementSetWindow(1);
    /*
    this.thinkEditor.DisplaySearchReplaceWindow(1);
           return;  */

    /*
//var json = {};
//json.display_revise_auxiliary = true;
//json.display_revise_del = false;
//json.display_qualitycontrol_infobox = false;
//json.display_comment_infobox = false;
json.display_carriage_return = false;
json.display_trim_marks = true;
this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, json);
        //this.thinkEditor.CloseAllDoc();
        //this.thinkEditor.DisplayEditToolBar(E_DISPLAY_MODE.Hide);
        return;
        var init_config={
        doc_rename: "new1111", // #2e83f8

        };
	    this.thinkEditor.SetDocConfig("", init_config);
*/

    /*
	//var signImage = "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";
	var md5 = this.thinkEditor.SetImageResourceBase64("sign.bmp", signImage, signImage.length, "");// (E_VIEW_MODE::Edit);
	var signFragment = "<Fragment><Image width='2' height='0.8' file='当前医师电子签名.jpg' md5='" + md5 + "'/></Fragment>";

	this.thinkEditor.SetElementContent("sign", signFragment);
*/
    //this.handleFullScreen();
    //var doc_name = this.thinkEditor.GetVisibleDocName();
    //this.thinkEditor.CloseDoc(doc_name);

    /*
       //---------------
        var init_config={
        tab_color: "FF2E83F9", // #2e83f8
       //tab_hovered_color: "FF83BDFF", // #82beff
       //tab_active_color: "FF0076FF", //
        };
        //init_config.tab_color = "ffff0000";//0xffff0000;
	    this.thinkEditor.SetEditorConfig(init_config);
*/

    //this.thinkEditor.ResizeViewPanel(1000,1000);
    //---------------
    //this.thinkEditor.CloseAllDoc();

    //---------------
    //var ret =  this.thinkEditor.SetSelectContentLock(true);
    //var ret =  this.thinkEditor.InsertElement("test", "请输入", "", "[", "]", "", "");
    //var test = this.thinkEditor.GetSelectRangeContent(E_DOC_FORMAT.TEXT);
    //---------------
    /*
    var json_obj={};
    json_obj.display = 0;
    //json_obj["top-border-style"] = 0;
    this.thinkEditor.SetHeaderConfig(json_obj);
    this.thinkEditor.SetFooterConfig(json_obj);
    */
    //-------------------
    //this.thinkEditor.GetSelectDocName();
    //var editorContainer = this.$refs.editorContainer;
    //editorContainer.width = 1000;
    //editorContainer.height = 1000;
    // this.thinkEditor.ResizeViewPanel(1000,1000);
    //var ret = this.thinkEditor.SetElementContent("简要诊断", '<Fragment><Format size=\"0.776\" />XXX人民医院</Fragment>');
    //---------------
    //var cfg = new SeparatorCfg();
    //cfg.all = 0;
    //cfg.independent_line_ = true;

    //---------------
    // this.thinkEditor.DisplayBarCodeSetWindow(E_DISPLAY_MODE.Show,E_SET_MODE.InsertSpecial);
    //this.thinkEditor.DisplayImageSetWindow(E_DISPLAY_MODE.Show,E_SET_MODE.SM_INSERT_COMMON);

    //---------------
    //var docname = this.thinkEditor.GetSelectDocName();
    //console.log(docname);
    //docname = this.thinkEditor.GetVisibleDocName();
    //console.log(docname);
    //---------------
    //      this.thinkEditor.SetParagraphAlignContent(E_ALIGN_HORIZONTAL_MODE.Center);
    //---------------
    // var outline = this.thinkEditor.GetOutline();
    // var gotoOutline =`{\"type\":\"Section\",\"index\":0,\"content\":{\"type\":\"Main\",\"Paragraph\":{\"type\":\"Paragraph\",\"id\":\"主诉\",\"name\":\"\",\"level\":0,\"index\":3,\"member\":{\"type\":\"Element\",\"id\":\"简要诊断\",\"name\":\"\"}}}}`;
    //var ret = this.thinkEditor.GotoOutline(gotoOutline);

    //---------------
    //this.thinkEditor.DisplayElementSetWindow(E_DISPLAY_MODE.Show,E_SET_MODE.SM_INSERT_COMMON);
    //---------------
    //this.thinkEditor.SetParagraphSpaceBefore(1);
    //---------------
    //this.thinkEditor.SetFontFerrule(E_FERRULE_MODE.Circle);
    //---------------
    //this.thinkEditor.SetBackgroundColor(this.$BuildTEColorByStr("rgb(66, 133, 244)"));
  }

  /*
     SetViewMode
CancelCompareDocs
Paste
Exit
CloseAllDoc
SetTableConfig_显示表格线
     */

  Test2() {
    var testCode = 'SetTableConfig_显示表格线';

    var thinkEditor = this.thinkEditor;
    switch (testCode) {
      case 'SetTableConfig_显示表格线': {
        thinkEditor.SetTableConfig('table', {
          border: {
            apply: 'table',
            borderStyle: 1,
            topBorder: 1,
            bottomBorder: 1,
            leftBorder: 1,
            rightBorder: 1,
            innerHorizontalBorder: 1,
            innerVerticalBorder: 1
          }
        });
        break;
      }
      case 'InputFragment': {
        this.thinkEditor.InputFragment('泰伦');
        break;
      }
      case 'SetElementContent': {
        thinkEditor.SetElementContent('婚姻', '已婚');
        break;
      }
      case 'SetCommentResolve': {
        thinkEditor.SetCommentResolve({ resolve: true });
        break;
      }
      case 'CloseAllDoc':
        this.thinkEditor.CloseAllDoc();
        break;
      case 'GetDocProperties':
        let v = this.thinkEditor.GetDocProperties();
        break;
      case 'SetDocConfig':
        this.thinkEditor.SetDocConfig('', { disableParagraphLockedTip: 0 });
        break;
      case 'testDump1':
        this.thinkEditor.SetEditorConfig({ testDump1: 1 });
        break;
      case 'Exit':
        this.thinkEditor.Exit();
        break;
      case 'Paste':
        this.thinkEditor.Paste(E_PASTE_TYPE.Normal);
        break;
      case 'SetViewMode':
        this.thinkEditor.SetViewMode(E_VIEW_MODE.Print, {});
        break;
      case 'CancelCompareDocs':
        var json_cfg = {};
        json_cfg.retainDocs = true;
        this.thinkEditor.CancelCompareDocs(json_cfg);
        break;
      default:
        break;
    }

    return;
    /*
            this.thinkEditor.SetElementContent("6CAEC966-0CC7-4C7D-ACFC-8436704A4708", "5689");
            this.thinkEditor.GetDoc(1,0);
            return;
            */
    /*
this.thinkEditor.DisplayImageEdit(1);
return;*/

    var json = {};
    /*
 json.display_edit_auxiliary = true;//change
 json.display_selection_effect = true;
 json.display_revise_auxiliary = true;
 json.display_revise_del = true;
 json.display_qualitycontrol_infobox = false;
 json.display_comment_infobox = true;
*/
    json.displayCommentBgMode = 2;
    //json.display_trim_marks = false;
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit, json);
    //this.thinkEditor.DisplayEditToolBar(E_DISPLAY_MODE.Hide);
    return;
    var json_obj = {};
    json_obj.display = 1;
    //json_obj["top-border-style"] = 0;
    this.thinkEditor.SetHeaderConfig(json_obj);
    this.thinkEditor.SetFooterConfig(json_obj);
  }
  SetUserDefinedMenuDemo() {
    var json_str = `[{"type":"user_defined1","text":"自定义菜单1","code":0},{"type":"user_defined2","text":"自定义菜单2","code":2}]`;
    var json_obj = JSON.parse(json_str);
    this.thinkEditor.SetUserDefinedMenu(json_obj);
  }
  SetViewModeShowReviseEdit(thinkEditor) {
    thinkEditor.SetEditorInfo('pc', '12666', 'admin', 1, { note: '上级医师审阅修改' });
    thinkEditor.SetEditMode(true, true, true, true);
    thinkEditor.SetViewMode(E_VIEW_MODE.Edit, { displayReviseAuxiliary: true, displayReviseDel: true });
  }
  SetViewModeHideReviseEdit(thinkEditor) {
    thinkEditor.SetEditorInfo('pc', '12666', 'admin', 1, { note: '上级医师审阅修改' });
    thinkEditor.SetEditMode(true, true, true, true);
    thinkEditor.SetViewMode(E_VIEW_MODE.Edit, { displayReviseAuxiliary: false, displayReviseDel: false });
  }
  SetViewModeNullReviseEdit(thinkEditor) {
    thinkEditor.SetEditorInfo('pc', '12666', 'admin', 1, { note: '上级医师审阅修改' });
    thinkEditor.SetEditMode(false, false, false, false);
    thinkEditor.SetViewMode(E_VIEW_MODE.Edit);
  }
  CancelSign() {
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit);
    this.thinkEditor.SetElementContent('sign', '');
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Browse);
  }

  async SelectImage() {
    var fileData = await PopFileSelector('.jpg,.svg,.bmp,.png,');
    var data = fileData.data;
    var imgName = fileData.fileName;
    this.thinkEditor.InsertImage('', 0, 0, imgName, data, data.byteLength, {});
  }
  RandomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
  async OpenDoc() {
    var docData = await PopFileSelector('.xml,');
    var docName = docData.fileName; //this.RandomString(9);
    var data = docData.data;
    /************************
     * 方案一：简化示例 没有加载资源
     * *************************/
    //this.thinkEditor.CreateDoc(doc_name);
    //this.thinkEditor.ParseDoc(doc_name, data, E_DOCS_ORGANIZE_MODE.Single);
    //this.thinkEditor.SetDisplayScale(E_PAGES_LAYOUT_MODE.Ratio, 1.2);
    //this.thinkEditor.SetViewMode(E_VIEW_MODE.Edit);
    /************************
     * 方案二：通用演示
     * *************************/
    this.OpenEmrCommon(docName, data);
  }
  NewTemplateDoc() {
    var doc_name = this.RandomString(9);
    this.OpenEmr(doc_name, E_DOC_TYPE.Template, 'empty.xml');
    this.PreLoadTemplateSource();
  }
  async NewEntityDoc() {
    //this.thinkEditor.CloseAllDoc();
    var doc_name = this.RandomString(9);
    await this.OpenEmr(doc_name, E_DOC_TYPE.Entity, 'empty.xml');
    /*
            const new_doc =`<Doc>
     <Sections>
      <Section>
       <Main>
        <Paragraph id="1212">
        段落内容
        </Paragraph>
       </Main>
      </Section>
     </Sections>
     <Resources />
    </Doc>`

    const json_cfg={};
    json_cfg.replace_main_content = true;
    this.thinkEditor.AppendFragment('',new_doc, json_cfg);

    const json_p_cfg={};
    json_p_cfg.forbid_series_split =true;
    json_p_cfg.split_paragrah_mode =2;
    this.thinkEditor.SetParagraphConfig("1212",json_p_cfg);
    */
  }
  async NewTimeAxis() {
    var url = '/system/emr/TemperatureTimeAxis.xml'; //"/system/test/pacsdemo.jpg";
    //var thinkEditorDemo = this;
    let response = await fetch(url, {
      credentials: 'same-origin'
    });
    let data = await response.arrayBuffer();
    //response.arrayBuffer().then(data =>  {
    var doc_name = '体温单' + ((Math.random() * 1000000) | 0);
    this.OpenEmrCommonHandle(doc_name, data);

    var d = new Date();
    var timeS = parseInt(d.getTime() / 1000);

    var json = {};
    json['id'] = '';
    json['startTime'] = timeS; //注意传float 编辑器json会读取不到数据，需使用parseInt
    json['endTime'] = timeS + 6 * 86400; //当前页面宽度 6天为一页
    this.thinkEditor.SetTimeGridConfig(json);
    this.thinkEditor.UpdateTimeAxis('');
    this.thinkEditor.SetViewMode(E_VIEW_MODE.Browse);
  }
  SaveToImage() {
    var dataBuffer = this.thinkEditor.GetPagesImage(E_IMAGE_TYPE.JPG, 0, 2, 1);
    ShowSaveFileDialog('thinkeditor.jpg', dataBuffer);
  }
  SaveToPdfView() {
    var dataBuffer = this.thinkEditor.GetPagesPDF(0, 0, 1.5, 0);
    ShowSaveFileDialog('thinkeditor.pdf', dataBuffer);
  }
  async SaveToPdf() {
    var dataBuffer = await this.thinkEditor.GetPDF({});
    ShowSaveFileDialog('thinkeditor.pdf', dataBuffer);
  }
  SaveToXml(docType = E_DOC_TYPE.Entity) {
    //step1: 获取文档的xml
    var docData = this.thinkEditor.GetDoc(E_DOC_FORMAT.XML, E_DOC_TYPE.Entity, { formatPretty: true });
    //step2: 应用对xml的使用（保存到本地或数据库）。当前示例：保存到本地
    ShowSaveFileDialog('thinkeditor.xml', docData);
  }
  SaveToXmlTemplate() {
    var docData = this.thinkEditor.GetDoc(E_DOC_FORMAT.XML, E_DOC_TYPE.Template, { formatPretty: true });
    ShowSaveFileDialog('thinkeditorTemplate.xml', docData);
  }
  SaveToDocText() {
    var docData = this.thinkEditor.GetDoc(E_DOC_FORMAT.TEXT, E_DOC_TYPE.Entity, {});
    ShowSaveFileDialog('thinkeditorDocText.txt', docData);
  }
  SaveToDocJson() {
    var outlineObj = this.thinkEditor.GetOutline({ mode: 2 });
    ShowSaveFileDialog('thinkeditorDocJson.json', JSON.stringify(outlineObj));
  }
  PrintDoc() {
    let printCfg = {};
    printCfg.printMode = 1; //0:视图打印 1：矢量打印
    printCfg.view = {
      mode: E_VIEW_MODE.Print,
      hideElementHint: true
    };
    this.thinkEditor.PrintDoc(printCfg);
  }
  SaveToHtml() {
    var dataBuffer = this.thinkEditor.GetDoc(E_DOC_FORMAT.HTML, E_DOC_TYPE.Entity);
    ShowSaveFileDialog('thinkeditor.html', dataBuffer);
  }
  SaveToImg() {
    var dataBuffer = this.thinkEditor.GetPagesImage(E_IMAGE_TYPE.JPG, 0, 2, 1);
    ShowSaveFileDialog('thinkeditor.jpg', dataBuffer);
  }
  async InsertImage() {
    var url = '/system/test/sign.svg'; //"/system/test/pacsdemo.jpg";
    let response = await fetch(url, {
      credentials: 'same-origin'
    });
    let data = await response.arrayBuffer();
    await this.thinkEditor.InsertImage('', 0, 0, 'pacsdemo', data, data.byteLength, {});
  }
  async LoadSystemKnowledge() {
    var json_str = `[
	{
		"class": "系统123",
		"Options": [
			{
				"id": "属地567",
				"multiple_choice": false,
				"group_exclusion": true,
				"Items": [
					{
						"id": "本县区888",
						"group-id": "",
						"weight": 1.00,
						"content": "*fragment_base64*"
					},
					{
						"id": "本市其他县区",
						"group-id": "",
						"weight": 1.00
					},
					{
						"id": "本省其他地市",
						"group-id": "",
						"weight": 1.00
					},
					{
						"id": "外省",
						"group-id": "",
						"weight": 1.00
					},
					{
						"id": "港澳台",
						"group-id": "",
						"weight": 1.00
					},
					{
						"id": "外籍",
						"group-id": "",
						"weight": 1.00
					}
				]
			}
		]
	}
]`;
    let thinkEditor = this.thinkEditor;
    var json_obj = JSON.parse(json_str);
    thinkEditor.AddSystemKnowledge(json_obj);
    /************************************
     * 加载 系统知识库，比如姓别 省份
     * ***********************************/

    var url = '/system/knowledge/System/System.xml';
    let response_system = await fetch(url, {
      credentials: 'same-origin'
    }); //.then(function (response) {
    let data_system = await response_system.arrayBuffer();
    thinkEditor.AddSystemKnowledge(data_system);

    /************************************
     * 加载通用知识库
     * ***********************************/

    var url = '/system/knowledge/Common/CommonSymptoms.xml';
    let response_common = await fetch(url, {
      credentials: 'same-origin'
    }); //.then(function (response) {
    let data_common = await response_common.arrayBuffer();
    thinkEditor.AddSystemKnowledge(data_common);
  }
  async LoadDocKnowledge(doc_class) {
    /************************************
     * 加载科室知识库
     * ***********************************/
    let thinkEditor = this.thinkEditor;
    if (doc_class == '呼吸科') {
      var url = '/system/knowledge/Respiratory/Respiratory.xml';
      let response = await fetch(url, {
        credentials: 'same-origin'
      });
      let data = await response.arrayBuffer();
      thinkEditor.AddDocKnowledge(doc_class, data);
    } else if (doc_class == '感染科') {
      var url = '/system/knowledge/InfectiousDisease/InfectiousDiseaseCard.xml';
      let response = await ffetch(url, {
        credentials: 'same-origin'
      });
      let data = await response.arrayBuffer();
      thinkEditor.AddDocKnowledge(doc_class, data);
    }
  }
  InsertFormula() {
    this.thinkEditor.InsertFormula({ id: '', style: E_FORMULA_STYLE.MensesStyle_1, alignVerticalLayout: E_LAYOUT_VERTICAL_ALIGN.OtherMiddle });
  }
  InsertCheckBox() {
    this.thinkEditor.InsertCheckBox({ id: '', weight: 0, content: '选框示例', checkFigureStyle: E_CHECK_FIGURE_STYLE.STYLE_1 });
  }
  InsertQRCode() {
    this.thinkEditor.InsertBarCode({ id: '', width: 1.5, height: 1.5, data: Base64.encode('123456789'), type: E_BARCODE_TYPE.QRCODE });
  }
  InsertBarCode() {
    this.thinkEditor.InsertBarCode({ id: '', width: 3, height: 1.5, data: Base64.encode('123456789'), type: E_BARCODE_TYPE.CODE128 });
  }
  InsertElement() {
    //this.thinkEditor.InsertElement("test", "请输入", "", "[", "]", "体温", "C");
    //"test", "请输入", "", "[", "]", "", ""
    let jsonCfg = {
      id: 'test',
      hint: '请输入',
      tip: '',
      beginBorder: '[',
      endBorder: ']',
      beforeTag: '',
      afterTag: ''
    };
    this.thinkEditor.InsertElement(jsonCfg);

    var ele_cfg = new ElementCfg();
    ele_cfg.dynamic_load_ = false;
    //示例：设置引用源
    this.thinkEditor.SetElementSource('test', '基本资料', '医保号', ele_cfg);

    //示例：设置选项输入
    ele_cfg.multiple_choice_ = false;
    //this.thinkEditor.SetElementSelectOption("", "系统", "良好程度", "",ele_cfg);
    //this.thinkEditor.SetElementSelectOption("", "系统123", "属地567", "",ele_cfg);
    //this.thinkEditor._SetEditorCanvasFoucs(true);
    //this.Module.canvas = canvasObj;
  }

  async InsertFragment(fragment_file) {
    var url = '/system/fragment/' + fragment_file;
    let response = await fetch(url, {
      credentials: 'same-origin'
    });
    let data = await response.arrayBuffer();
    this.thinkEditor.InputFragment(data);
  }
  async AppendFragment(fragment_file) {
    var url = '/system/fragment/' + fragment_file;
    let response = await fetch(url, {
      credentials: 'same-origin'
    });
    let data = await response.arrayBuffer();
    //this.thinkEditor.ParseDoc("",data, E_DOCS_ORGANIZE_MODE.UnionContent);
    var json_cfg = {};
    //json_cfg.replace_main_content = true;
    this.thinkEditor.AppendFragment('', data, json_cfg);
  }

  PreLoadEntitySourceData() {
    let thinkEditor = this.thinkEditor;
    thinkEditor.SetSource('认证', '机构名', "<Fragment><Format size='0.776' />江东第一人民医院</Fragment>");

    /********************病人基础资料*************************/
    thinkEditor.SetSource('基本资料', '姓名', '张小北');
    thinkEditor.SetSource('基本资料', '性别', '男');
    thinkEditor.SetSource('基本资料', '身份证', '5131246845698xxxxx');
    thinkEditor.SetSource('基本资料', '年龄', '23');
    thinkEditor.SetSource('基本资料', '民族', '汉');
    thinkEditor.SetSource('基本资料', '医保号', '1982309');

    //--------
    //this.thinkEditor.SetSource("门诊资料", "门诊号", "237899");
    thinkEditor.SetSource('门诊资料', '门诊号', "<Fragment><BarCode width='1.50' height='1.50' cfg='13a'>MTIzNDU2Nzg5</BarCode></Fragment>"); // "237899");

    thinkEditor.SetSource('住院资料', '住院号', 'new163679'); //163679
    thinkEditor.SetSource('住院资料', '科室', '骨科');
    thinkEditor.SetSource('住院资料', '病房', '6');
    thinkEditor.SetSource('住院资料', '床号', '16');
    thinkEditor.SetSource('住院资料', '入院时间', '2019-09-09 09:16:23');

    /***********************************
     * 设置图片源-此处用作签名
     * md5为图片二进制数据对应的md5码
     * 注意：图片数据在"imageResource.request"事件中调用SetImageResource/SetImageResourceBase64设置
     * 详见《设计手册-图像》
     * ************************************/
    var md5 = 'a04cfa91f403f799ce07252e85bda12b'; //md5必需为图片真实md5值
    var signSource = "<Fragment><Image width='2' height='0.8' file='当前医师电子签名.jpg' md5='" + md5 + "'/></Fragment>";
    thinkEditor.SetSource('医师资料', '电子签名', signSource);
    /*******************上级医师********************/
    md5 = 'b3aa75a6c69fb17ec3cc4290bbea8a57'; //md5必需为图片真实md5值
    signSource = "<Fragment><Image width='2' height='0.8' file='审核医师电子签名.jpg' md5='" + md5 + "'/><Format color='c93756' size='0.6'/>/</Fragment>";
    thinkEditor.SetSource('医师资料', '审核医师签名', signSource);
  }
  /**
   * 预设空数据源，用于编辑模板时元素-源类型选框中有对应数据
   * SetSource的source-class、source-id参数都是由应用自行规划取名和分类的
   * @memberof ThinkEditorDemo
   */
  PreLoadTemplateSource() {
    console.log('PreLoadTemplateSource');
    var thinkEditor = this.thinkEditor;
    thinkEditor.SetSource('认证', '机构名', '');
    /********************病人基础资料*************************/
    thinkEditor.SetSource('基本资料', '姓名', '');
    thinkEditor.SetSource('基本资料', '性别', '');
    thinkEditor.SetSource('基本资料', '身份证', '');
    thinkEditor.SetSource('基本资料', '年龄', '');
    thinkEditor.SetSource('基本资料', '民族', '');
    thinkEditor.SetSource('基本资料', '医保号', '');

    //--------
    thinkEditor.SetSource('门诊资料', '门诊号', '');

    thinkEditor.SetSource('住院资料', '住院号', '');
    thinkEditor.SetSource('住院资料', '科室', '');
    thinkEditor.SetSource('住院资料', '病房', '');
    thinkEditor.SetSource('住院资料', '床号', '');
    thinkEditor.SetSource('住院资料', '入院时间', '');
    /***********************************
     * 设置图片源-此处用作签名
     * md5为图片二进制数据对应的md5码
     * 注意：图片数据在"imageResource.request"事件中调用SetImageResource/SetImageResourceBase64设置
     * 详见《设计手册-图像》
     * ************************************/
    var md5 = 'a04cfa91f403f799ce07252e85bda12b'; //md5必需为图片真实md5值
    var signSource = "<Fragment><Image width='2' height='0.8' file='当前医师电子签名.jpg' md5='" + md5 + "'/></Fragment>";
    thinkEditor.SetSource('医师资料', '电子签名', signSource);
    /*******************上级医师********************/
    md5 = 'b3aa75a6c69fb17ec3cc4290bbea8a57'; //md5必需为图片真实md5值
    signSource = "<Fragment><Image width='2' height='0.8' file='审核医师电子签名.jpg' md5='" + md5 + "'/><Format color='c93756' size='0.6'/>/</Fragment>";
    thinkEditor.SetSource('医师资料', '审核医师签名', signSource);
  }

  /**
   * 供应用参考的封装打开文档的方法
   *
   * @param {string} doc_name
   * @param {string or ArrayBuffer} data
   * @param {E_DOC_TYPE} doc_type
   * @memberof ThinkEditorDemo
   */
  OpenEmrCommonHandle(doc_name, data, doc_type, enableRevise) {
    let cluster_name = doc_name;
    let thinkEditor = this.thinkEditor;

    thinkEditor.CreateDoc(cluster_name);
    thinkEditor.SelectDoc(cluster_name);
    //thinkEditor.VisibleDoc(cluster_name);
    /*V2版本 改为 CreateDocEditor后，加载对应源到DocEditorEntity
    if (doc_type == E_DOC_TYPE.Template) {
      //note:编辑模板前需预设空Source
      this.PreLoadTemplateSource();
    } else if (doc_type == E_DOC_TYPE.Entity) {
      //note:编辑文档实体时，无需预设Source, 而是动态获取，详见setElementContent.request事件处理
      this.PreLoadEntitySourceData(); //@20220610为演示方便，增加加载签名Source
    }

    */
    /*
        必需先解析ParseDoc文档中的编辑信息，再加载此次的编辑者信息
    */
    //thinkEditor.SetEditorInfo("pc", "12666", "admin", 0, {"note":"上级医师审阅修改"});//考虑到json_str xml_str存放可以扰乱xml问题attach_str=json_str
    /*
        SetEditorInfo的attrs_json参数和格式由用户自定义
    */
    var attrs_json = {};
    attrs_json.note = '上级医师审阅修改';
    thinkEditor.SetEditorInfo('pc', '12666', 'admin', 1, attrs_json); //考虑到json_str xml_str存放可以扰乱xml问题attach_str=json_str

    /*
    enable_permission:[是否可删除]启用文档内容安全和权限控制。默认为false文档内容可任意编辑。
    enable_revise:[是否逻辑删除 新增内容带痕]使能审阅模式。默认为false，正常编辑
    modify_same_level:能否修改或删除同授权等级的内容,默认为true
    force_modify: 高权限的是否可以修改低权限禁止删除、或禁止编辑的内容。 默认为false不可修改
    modify_owner_old_by_revise: 是否带痕修改自己曾经输入的内容，默认false,可直接删除自己写的旧内容
    */
    //thinkEditor.SetEditMode(true, true, true, true);

    //在加载文档之后，可修改

    thinkEditor.SetDocType(doc_type);

    thinkEditor.ParseDoc(cluster_name, data, {});

    if (enableRevise == 1) {
      thinkEditor.SetEditMode(true, true, true, true);
    } else {
      thinkEditor.SetEditMode(false, false, false, false);
    }

    thinkEditor.SetDocClass('呼吸科');
    thinkEditor.SetDisplayScale(E_PAGES_LAYOUT_MODE.Ratio, 1.0);

    //取得该文档需要的源信息
    //thinkEditor.SetViewMode(E_VIEW_MODE.Edit);
  }
  OpenEmrCommon(doc_name, data, doc_type, view_mode, enableRevise) {
    let thinkEditor = this.thinkEditor;

    this.OpenEmrCommonHandle(doc_name, data, doc_type, enableRevise);

    // if (this.thinkEditor._IsNull(view_mode)) {
    //   view_mode = E_VIEW_MODE.Edit;
    // }

    thinkEditor.SetViewMode(view_mode);

    var end1 = new Date().getTime();

    /*  //@20220226 测试痕迹
     const json = {};
     json.display_revise_auxiliary = true;
     json.display_revise_del = false;
     json.display_qualitycontrol_infobox = false;
     json.display_comment_infobox = false;
     json.display_edit_auxiliary = true;
     json.display_selection_effect = true;
     json.display_carriage_return = false;
     this.thinkEditor.SetViewMode(view_mode, json);//E_VIEW_MODE.Edit*
     */
  }

  /**
   * 示例：通过http获取病历并打开
   *
   * @param {string} doc_name
   * @param {E_DOC_TYPE} doc_type
   * @param {string} doc_file
   * @param {E_VIEW_MODE} view_mode
   * @memberof ThinkEditorDemo
   */
  async OpenEmr(doc_name, doc_type, docData, viewMode, enableRevise) {
    if (typeof doc_type === 'undefined') {
      doc_type = E_DOC_TYPE.Entity;
    }

    await this.OpenEmrCommon(doc_name, docData, doc_type, viewMode, enableRevise);
    let thinkEditor = this.thinkEditor;
    thinkEditor.SetDefaultFont('宋体', '小五');
  }
}
